import React from 'react';
import { SingleDropdownShared } from '@shared/components/Dropdowns/DesignSystem/SingleDropdown/SingleDropdownShared';
import { SingleDropdownProps } from '@shared/components/Dropdowns/DesignSystem/dropdown.interface';

export function SingleDropdown<T>(props: SingleDropdownProps<T>) {
	return <SingleDropdownShared {...props} />;
}
